import PropTypes from 'prop-types';
import styles from './Footer.module.scss';

function Footer({ credits }) {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.body}>
          <div className={styles.logo}>
            <a href="https://complexchinese.com/">
              <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="COMPLEX 中文" />
            </a>
          </div>
          <div className={styles.links}>
            <div className={styles.link}>
              <a href="https://complexchinese.com/tc/about-us" target="_blank" rel="noreferrer">關於我們</a>
            </div>
            <div className={styles.link}>
              <a href="https://complexchinese.com/tc/term-and-conditions" target="_blank" rel="noreferrer">網站聲明</a>
            </div>
            <div className={styles.link}>
              <a href="https://complexchinese.com/tc/privacy-policy" target="_blank" rel="noreferrer">隱私政策</a>
            </div>
          </div>
          <div className={styles.affiliate}>
            COMPLEX participates in various affiliate marketing programs, which means COMPLEX gets paid commissions on purchases made through our links to retailer sites. Our editorial content is not influenced by any commissions we receive.
          </div>
          <div className={styles.copyright}>
            &copy; Complex Media Inc. All Rights Reserved
          </div>
          <div className={styles.part}>
            Complex.com is a part of
          </div>
          <div className={styles.complexNetworks}>
            <a href="https://www.complexnetworks.com/" target="_blank" rel="noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/complex-networks.svg`} alt="COMPLEX NETWORKS" />
            </a>
          </div>
        </div>

        <div className={styles.credits}>
          <div className={styles.heaading}>CREDITS</div>
          <ul className={styles.list}>
            {
              credits.map((credit, index) => (
                <li key={`footer-credits-${index}`} className={styles.listItem}>
                  {
                    credit.title && (
                      <span className={styles.title}>{credit.title}</span>
                    )
                  }
                  <span className={styles.name}>
                    {
                      credit.name === 'MATT YIU' ? (
                        <a href="mailto:enquiry.cp@mtyiu.site">
                          {credit.name}
                        </a>
                      ) : (
                        credit.name
                      )
                    }
                  </span>
                </li>
              ))
            }
          </ul>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  credits: PropTypes.array.isRequired,
};

export default Footer;
